import {
  GET_ACTION_BY_CHAPTER_PRIV_ID,
  GET_AVAILABLE_ACTION_BY_CHAPTER_PRIV_ID,
  GET_CHAPTERS_BY_ROLE,
  GET_CHAPTERS_BY_USER_ID,
  GET_MENU_ACTIONS_ALL,
  GET_MENU_CHAPTERS_ALL,
} from "../types";

const initialState = {
  menuChapters: [],
  chaptersByRole: [],
  menuActions: [],
  availableActionByChapterId: [],
  actionByChapterId: [],
  availableChapters: [],
};

export const roleManagementReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_MENU_CHAPTERS_ALL:
      return (() => ({
        ...state,
        menuChapters: action.data,
      }))();
    case GET_CHAPTERS_BY_ROLE:
      return (() => ({
        ...state,
        chaptersByRole: action.data,
      }))();
    case GET_CHAPTERS_BY_USER_ID:
      return (() => ({
        ...state,
        availableChapters: action.data,
      }))();
    case GET_MENU_ACTIONS_ALL:
      return (() => ({
        ...state,
        menuActions: action.data,
      }))();
    case GET_AVAILABLE_ACTION_BY_CHAPTER_PRIV_ID:
      return (() => ({
        ...state,
        availableActionByChapterId: action.data,
      }))();
    case GET_ACTION_BY_CHAPTER_PRIV_ID:
      return (() => ({
        ...state,
        actionByChapterId: action.data,
      }))();
    default:
      return state;
  }
};
